/* AFS B2B — predictive search with exact-identifier priority, recent
   searches, keyboard navigation, and no-result recovery (scope §5/§7). */
(function () {
  'use strict';

  var cfg = window.AFSConfig || { routes: {} };
  var RECENT_KEY = 'afs:recent-searches';

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
  }
  function pushRecent(term) {
    try {
      var list = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6)));
    } catch (e) { /* unavailable */ }
  }

  document.querySelectorAll('[data-predictive-search]').forEach(function (root) {
    var input = root.querySelector('input[type="search"], input[type="text"]');
    var panel = root.querySelector('.predictive-search');
    var form = root.querySelector('form');
    if (!input || !panel) return;

    var debounceTimer = null;
    var abortController = null;
    var activeIndex = -1;

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('autocomplete', 'off');

    function open() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); activeIndex = -1; }

    function options() { return Array.prototype.slice.call(panel.querySelectorAll('.predictive-search__item, .predictive-search__footer')); }

    function highlight(idx) {
      var opts = options();
      opts.forEach(function (o, i) { o.setAttribute('aria-selected', String(i === idx)); });
      if (opts[idx]) opts[idx].scrollIntoView({ block: 'nearest' });
      activeIndex = idx;
    }

    function renderRecent() {
      var recent = getRecent();
      if (!recent.length) { close(); return; }
      panel.innerHTML = '';
      var group = document.createElement('div');
      group.className = 'predictive-search__group';
      var h = document.createElement('div');
      h.className = 'predictive-search__heading';
      h.textContent = panel.getAttribute('data-recent-label') || 'Recent searches';
      group.appendChild(h);
      recent.forEach(function (term) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'predictive-search__item';
        btn.setAttribute('role', 'option');
        btn.textContent = term;
        btn.addEventListener('click', function () {
          input.value = term;
          if (form) form.submit();
        });
        group.appendChild(btn);
      });
      panel.appendChild(group);
      open();
    }

    function fetchResults(term) {
      if (abortController) abortController.abort();
      abortController = new AbortController();
      var url = cfg.routes.predictiveSearch +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,page,article,collection' +
        '&resources[limit]=8&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag' +
        '&section_id=predictive-search-results';
      fetch(url, { signal: abortController.signal })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var results = doc.querySelector('#PredictiveSearchResults');
          panel.innerHTML = results ? results.innerHTML : '';
          if (panel.innerHTML.trim()) open(); else close();
        })
        .catch(function (err) { if (err.name !== 'AbortError') close(); });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      window.clearTimeout(debounceTimer);
      if (term.length < 2) { renderRecentOrClose(term); return; }
      debounceTimer = window.setTimeout(function () { fetchResults(term); }, 220);
    });

    function renderRecentOrClose(term) {
      if (!term && root.hasAttribute('data-show-recent')) renderRecent();
      else close();
    }

    input.addEventListener('focus', function () {
      if (!input.value.trim() && root.hasAttribute('data-show-recent')) renderRecent();
    });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      var opts = options();
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(Math.min(activeIndex + 1, opts.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(Math.max(activeIndex - 1, 0)); }
      else if (e.key === 'Enter' && activeIndex >= 0 && opts[activeIndex]) {
        e.preventDefault();
        opts[activeIndex].click();
        if (opts[activeIndex].href) window.location.href = opts[activeIndex].href;
      }
      else if (e.key === 'Escape') { close(); }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });

    if (form) {
      form.addEventListener('submit', function () {
        var term = input.value.trim();
        if (term) pushRecent(term);
      });
    }
  });
})();
